import { Model } from '@vuex-orm/core'
import MZLocation from './MZLocation'
import MZLocationable from './MZLocationable'

export default class MZCoupon extends Model {
  static entity = 'mzcoupons'
  static primaryKey = 'id'

  static fields () {
    return {
      id: this.string(''),
      account_id: this.string(''),
      directory_list_coupons: this.string(''),
      name: this.string(''),
      description: this.string(''),
      disclaimer: this.string(''),
      type: this.string(''),
      amount: this.string(''),
      redemption_limit: this.string(''),
      redemption_count: this.string(''),
      has_all_redeemed: this.string(''),
      image: this.string(''),
      plu_code: this.string(''),
      coverImage: this.string(''),
      availability: this.string(''),
      start_date: this.string(''),
      end_date: this.string(''),
      meta_data: this.string(''),
      social_share: this.attr(''),
      distance: this.string(''),
      locations: this.morphToMany(MZLocation, MZLocationable, 'location_id', 'locationable_id', 'locationable_type')
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/MZCoupon.js